// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------
const storedUser = JSON.parse(localStorage.getItem('_pildat'));
const userRole = storedUser?.role; // Handle potential nullish value

console.log("User Role is", userRole)
const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const userSubMenu = [
  {
    title: 'Forms',
    path: '/dashboard/forms',
    icon: icon('ic_forms'),
  },
  {
    title: 'Document Templates',
    path: '/dashboard/templates',
    icon: icon('ic_templates'),
  },
  {
    title: 'Materials',
    path: '/dashboard/materials',
    icon: icon('ic_material'),
  },
  {
    title: 'Stripe',
    path: '/dashboard/stripe',
    icon: icon('ic_stripe'),
  },
  {
    title: 'XERO',
    path: '/dashboard/xero',
    icon: icon('ic_xero'),
  },
];

const usersSubMenu = [
  // {
  //   title: 'Add Users',
  //   path: '/dashboard/contact/add-contact',
  //   icon: <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="1.5em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 7a4 4 0 1 0 8 0a4 4 0 0 0-8 0M3 21v-2a4 4 0 0 1 4-4h4c.96 0 1.84.338 2.53.901M16 3.13a4 4 0 0 1 0 7.75M16 19h6m-3-3v6" /></svg>,
  //   disable: !(userRole === 'administrator' || userRole === 'verifier')
  // },
  {
    title: 'All Users',
    path: '/dashboard/users',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 256 256"><path fill="currentColor" d="M237 147.44a4 4 0 0 1-5.48-1.4c-8.33-14-20.93-22-34.56-22a4 4 0 0 1-1.2-.2a36.76 36.76 0 0 1-3.8.2a4 4 0 0 1 0-8a28 28 0 1 0-27.12-35a4 4 0 0 1-7.75-2a36 36 0 1 1 54 39.48c10.81 3.85 20.51 12 27.31 23.48a4 4 0 0 1-1.4 5.44M187.46 214a4 4 0 0 1-1.46 5.46a3.93 3.93 0 0 1-2 .54a4 4 0 0 1-3.46-2a61 61 0 0 0-105.08 0a4 4 0 0 1-6.92-4a68.35 68.35 0 0 1 39.19-31a44 44 0 1 1 40.54 0a68.35 68.35 0 0 1 39.19 31M128 180a36 36 0 1 0-36-36a36 36 0 0 0 36 36m-64-64a28 28 0 1 1 27.12-35a4 4 0 0 0 7.75-2a36 36 0 1 0-53.57 39.75a63.55 63.55 0 0 0-32.5 22.85a4 4 0 0 0 6.4 4.8A55.55 55.55 0 0 1 64 124a4 4 0 0 0 0-8" /></svg>,
  },
]


console.log(userRole == 's')
const navConfig = [
  {
    // title: 'Dashboard',
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
    disable: userRole && userRole == 'visitor'
  },
  {
    // title: 'View Profile',
    title: 'Profil (Unternehmensdaten)',
    path: '/dashboard/profile-details',
    icon: icon('ic_user'),
  },
  {
    // title: 'Listings',
    title: 'Einträge (Produktinnovationen)',
    path: '/dashboard/listings',
    icon: icon('ic_listings'),
  },
  {
    // title: 'Companies',
    title: 'Unternehmen',
    path: '/dashboard/companies',
    icon: icon('ic_companies'),
  },
  {
    // title: 'Events',
    title: 'Veranstaltungen',
    path: '/dashboard/events',
    icon: icon('ic_event'),
  },
  {
    // title: 'Categories',
    title: 'Kategorien',
    path: '/dashboard/categories',
    icon: icon('ic_category'),
  },
  {
    title: 'Werbebanner-Generator',
    path: '/dashboard/marketing',
    icon: icon('ic_banner'),
  },
  {
    title: 'Benachrichtigung',
    path: '/dashboard/notification',
    icon: icon('ic_bell'),
  },

  // {
  //   title: 'Manage Users',
  //   path: '/dashboard/user',
  //   icon: icon('ic_user'),
  //   children: usersSubMenu,
  // },
  // {
  //   title: 'Settings',
  //   path: '/dashboard/settings',
  //   icon: icon('ic_settings'),
  //   children: userSubMenu,
  // },
];

export const navConfigUser = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
    disable: userRole && userRole == 'visitor'
  },
  {
    title: 'Profil (Unternehmensdaten)',
    path: '/dashboard/profile-details',
    icon: icon('ic_user'),
  },
  {
    title: 'Einträge (Produktinnovationen)',
    path: '/dashboard/listings',
    icon: icon('ic_listings'),
  },
  {
    // title: 'Events',
    title: 'Veranstaltungen',
    path: '/dashboard/events',
    icon: icon('ic_event'),
  },
  {
    title: 'Werbebanner-Generator',
    path: '/dashboard/marketing',
    icon: icon('ic_banner'),
  },

  // {
  //   title: 'Manage Users',
  //   path: '/dashboard/user',
  //   icon: icon('ic_user'),
  //   children: usersSubMenu,
  // },
  // {
  //   title: 'Settings',
  //   path: '/dashboard/settings',
  //   icon: icon('ic_settings'),
  //   children: userSubMenu,
  // },
];


export default navConfig;
